export function generateErrorMessage(errorCode) {
    if(errorCode) {
        return `Something went wrong. Please try again later. Error Code ${errorCode}`
    }

    return "Something went wrong. Please try again later."
}